import { render, staticRenderFns } from "./Cupboard.vue?vue&type=template&id=c86eab98"
import script from "./Cupboard.vue?vue&type=script&lang=js"
export * from "./Cupboard.vue?vue&type=script&lang=js"
import style0 from "./Cupboard.vue?vue&type=style&index=0&id=c86eab98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports